export default {
  setTicketsForConsumption: (state, ticketsForConsumption) => {
    state.ticketsForConsumption = ticketsForConsumption
  },
  setConsumptionBatches: (state, consumptionBatches) => {
    state.consumptionBatches = consumptionBatches
  }
}
